import { render, staticRenderFns } from "./GPTContentDemo.vue?vue&type=template&id=1dfa2d27&scoped=true"
import script from "./GPTContentDemo.vue?vue&type=script&lang=js"
export * from "./GPTContentDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfa2d27",
  null
  
)

export default component.exports